const PhoneIconColor = ({ height = "20", width = "20", fill = "#3F83F8" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.44112 0.961776C6.14035 0.235245 5.34742 -0.151456 4.58964 0.0555658L1.15229 0.993024C0.472635 1.18052 0 1.79768 0 2.50077C0 12.1644 7.83559 20 17.4992 20C18.2023 20 18.8195 19.5274 19.007 18.8477L19.9444 15.4104C20.1515 14.6526 19.7648 13.8596 19.0382 13.5589L15.2884 11.9964C14.6517 11.7308 13.9134 11.9144 13.4799 12.4496L11.9018 14.3752C9.15194 13.0745 6.92548 10.8481 5.62475 8.09818L7.55045 6.52403C8.08558 6.08655 8.26917 5.35221 8.00355 4.71552L6.44112 0.965682V0.961776Z"
      fill={fill}
    />
  </svg>
);

export default PhoneIconColor;
